/*
 * @Description: 
 * @Author: zhaoshuai
 * @Date: 2020-05-07 13:41:28
 * @LastEditTime: 2020-10-22 11:20:00
 * @LastEditors: zhaoshuai
 */
import '@babel/polyfill'
import Es6Promise from 'es6-promise'

require('es6-promise').polyfill()
Es6Promise.polyfill()
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './http'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
// CNimport zhCN from 'antd/es/locale/zh_';
import moment from 'moment';
import 'moment/locale/zh-cn';
Vue.config.productionTip = false
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)
Vue.use(Antd)
moment.locale('zh-cn');
// //路由守卫
// router.beforeEach((to, from, next) => {
//     // console.log(to);
//     // console.log(from);
//     // console.log(JSON.parse(localStorage.getItem('loginStatus')))
//     // console.log(to.meta.loginStatus);
//     if (to.meta.loginStatus) { // 判断该路由是否需要登录权限
//         if (JSON.parse(localStorage.getItem('loginStatus'))) { //判断本地是否存在access_token
//             next();
//         } else {
//             next({
//                 path: `/login`,
//                 query: { redirect: router.currentRoute.path }
//             })
//         }
//     } else {
//         next();
//     }
//     /*如果本地 存在 token 则 不允许直接跳转到 登录页面*/
//     if (to.fullPath == "/login") {
//         if (JSON.parse(localStorage.getItem('loginStatus'))) {
//             next({
//                 path: from.fullPath
//             });
//         } else {
//             next();
//         }
//     }
// });
new Vue({
    router,
    store,
    axios,
    render: h => h(App)
}).$mount('#app')